module.exports = __webpack_public_path__ + "static/media/my-history.f42fe342.png";